/*
    This contains the theme store for the clients app-specific settings. Like colors, fonts, etc. So changes are stored here then when going to save or update the app we pull in the data from here.
*/

import { create } from "zustand";
import { combine } from "zustand/middleware";

type State = {
    textColor: string;
    backgroundColor: string;
    primaryColor: string;
    secondaryColor: string;
    accentColor: string;
    focusRingColor: string;
    fontFamily?: string;
};

type SetState = {
    setTheme: (theme: State) => void;
    setThemeValue: (key: keyof State | string, value: string) => void;
};

export const useThemeStore = create(
    combine<State, SetState>(
        {
            textColor: "#ffffff",
            backgroundColor: "#1c1c1c",
            primaryColor: "#1d48c9",
            secondaryColor: "#000000",
            accentColor: "#52e52a",
            focusRingColor: "#1d48c9",
            fontFamily: "Arial",
        },
        (set) => ({
            setTheme: (theme) => set(theme),
            setThemeValue: (key, value) =>
                set((state) => ({
                    ...state,
                    [key]: value,
                })),
        }),
    ),
);
